module.exports = $bonelibs.ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "$bonelibs.ReactDOM"
// module id = 10
// module chunks = 1 3 4 10